"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.detectTasks.name': '任务检测',
    'tools.detectTasks.description': '自动检测并提取用户消息中的任务信息',
};
